// Tratamento e validação de documentos (CPF/CNPJ).
//
// A partir de julho/2026 o CNPJ passa a ser alfanumérico: as 12 primeiras
// posições podem conter letras (A-Z) e dígitos (0-9) e os 2 últimos dígitos
// verificadores permanecem numéricos. O DV usa o valor (código ASCII - 48) de
// cada caractere, conforme nota técnica da Receita Federal.

export function sanitizeDocument(value = "") {
  // Mantém apenas alfanuméricos e normaliza em maiúsculo. Para CPF (somente
  // dígitos) o resultado é idêntico ao antigo strip numérico.
  return (value || "").toString().replace(/[^0-9a-zA-Z]/g, "").toUpperCase();
}

export function formatCnpj(value = "") {
  return sanitizeDocument(value).replace(
    /^([0-9A-Z]{2})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{4})(\d{2})/,
    "$1.$2.$3/$4-$5"
  );
}

// Formata CPF (11 dígitos) ou CNPJ (14, inclusive alfanumérico) conforme o tamanho.
export function formatDocument(value = "") {
  const document = sanitizeDocument(value);

  if (document.length === 14) {
    return formatCnpj(document);
  }
  if (document.length === 11) {
    return document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  }
  return document;
}

export function isValidCnpj(value = "") {
  const cnpj = sanitizeDocument(value);

  if (cnpj.length !== 14) {
    return false;
  }
  // Os dois dígitos verificadores são sempre numéricos.
  if (!/^\d{2}$/.test(cnpj.slice(12))) {
    return false;
  }
  // Rejeita documentos com todos os caracteres iguais.
  if (/^(.)\1{13}$/.test(cnpj)) {
    return false;
  }

  const checkDigit = (partial) => {
    let sum = 0;
    let weight = 2;
    for (let i = partial.length - 1; i >= 0; i--) {
      sum += (partial.charCodeAt(i) - 48) * weight;
      weight = weight === 9 ? 2 : weight + 1;
    }
    const mod = sum % 11;
    return mod < 2 ? 0 : 11 - mod;
  };

  const base = cnpj.slice(0, 12);
  const firstDigit = checkDigit(base);
  const secondDigit = checkDigit(base + firstDigit);

  return cnpj.slice(12) === `${firstDigit}${secondDigit}`;
}
